import * as React from "react";
import { createUseStyles } from "react-jss";
import { useHistory, useLocation } from "react-router-dom";
import { useAppMediaTypeCtx } from "@warda/library-ui/contexts/AppMediaTypeContext";
import { getTheme } from "@warda/library-ui/theme";
import emptyFn from "@warda/library-ui/utils/emptyFn";
import getFileIcon from "@warda/library-ui/utils/getFileIcon";
import Btn from "@warda/library-ui/core/Btn";
import { FileType, Initialize } from "@warda/library-ui/interfaces";
import { TYPE_FOLDER } from "@warda/library-ui/constants";
import CardContent from "../CardContent";
import CardTitle from "../CardTitle";
import { getFilesByDocumentId } from "../../../../api/fetchesApiMediaLibrary";
import { AREA } from "../../../AreaMediaLibrary/constants";
import { getQueryParams, updateSearchString, } from "../../../AreaMediaLibrary/searchString";
const COPY_TITLE = "Shared with you";
const TOOLTIP_MISSING = "It is no longer available.";
const useStyles = createUseStyles({
    btn: {
        maxWidth: 350,
    },
});
const CardShare = ({ cardClasses, dispatch, notifDrc }) => {
    var _a, _b;
    const classes = useStyles();
    const appMediaTypeCtx = useAppMediaTypeCtx();
    const queryHistory = useHistory();
    const querySearch = useLocation().search;
    const { area } = getQueryParams();
    const handleClick = React.useCallback(() => {
        updateSearchString({
            history: queryHistory,
            search: querySearch,
            area: AREA.SHARED_WITH_ME,
            path: null,
        });
    }, [queryHistory, querySearch]);
    const { documentId: id, name, elementType: fileType, } = notifDrc === null || notifDrc === void 0 ? void 0 : notifDrc.payload;
    const [idsWsInit, setIdsWsInit] = React.useState(Initialize.NONE);
    const [file, setFile] = React.useState(undefined);
    React.useEffect(() => {
        (async () => {
            if (idsWsInit === Initialize.NONE) {
                try {
                    setIdsWsInit(Initialize.WAIT);
                    if (id !== undefined) {
                        const area = AREA.SHARED_WITH_ME;
                        const files = await getFilesByDocumentId({
                            area,
                            hrch: undefined,
                            mediaIds: fileType == FileType.MEDIA ? [id] : [],
                            folderIds: fileType == FileType.FOLDER ? [id] : [],
                        });
                        setFile(files === null || files === void 0 ? void 0 : files[0]);
                    }
                    setIdsWsInit(Initialize.SUCC);
                }
                catch {
                    setIdsWsInit(Initialize.FAIL);
                }
            }
        })();
    }, [fileType, id, idsWsInit]);
    if (name === undefined || fileType === undefined)
        return null;
    const mimeType = fileType === FileType.MEDIA
        ? ((_b = (_a = file === null || file === void 0 ? void 0 : file.data) === null || _a === void 0 ? void 0 : _a.mimeType) !== null && _b !== void 0 ? _b : "??")
        : TYPE_FOLDER;
    const icon = getFileIcon(mimeType, appMediaTypeCtx.mimeTypeToMediaKind, fileType);
    return (React.createElement(React.Fragment, null,
        React.createElement(CardTitle, { classes: cardClasses, dispatch: dispatch, title: COPY_TITLE, notifDrc: notifDrc }),
        React.createElement(CardContent, { classes: cardClasses },
            React.createElement(Btn, { className: classes.btn, icon: icon, label: name, disabled: !file, variant: "light", onClick: !!file && area !== AREA.SHARED_WITH_ME && handleClick, tooltip: !file && TOOLTIP_MISSING }),
            React.createElement(Btn, { small: true, color: getTheme().colors.theme2, icon: "content_copy", copyToClipboard: name, onClick: emptyFn, tooltip: `Copy ${name} in clipboard` }))));
};
export default CardShare;
